import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import moment from 'moment-timezone';
import { getMyCRQCoordinatorCrqDashboard } from 'AppSrc/core/crq/crq-queries';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { CrqListErrorAlert } from 'AppSrc/core/components/crqs-screen/crq-list-error-alert';
import { MyCoordinatorWorkQueueDisplay } from './mycrq-coordinator-work-queue-display';
import { DEFAULT_TAB, INITIAL_COMMS_SENT, APPROVED } from './coordinator-work-queue-constants';
// import { IMPACT_LEVEL_1, IMPACT_LEVEL_2 } from '../forms/value-dependency-constants';

// container component with state
class MyCoordinatorWorkQueue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: DEFAULT_TAB,
      stats: {},
      crqLists: null,
      fetching: false,
      hasError: false,
    };
    this.handleTabClick = this.handleTabClick.bind(this);
    this.fetchCrqData = this.fetchCrqData.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  componentDidMount() {
    const newTab = JSON.parse(window.sessionStorage.getItem('MyBucketTabSession'));
    const lastTab = newTab ? newTab.slice(-1)[0] : DEFAULT_TAB;
    // setState from default tp selected tab session
    this.setState({ selectedTab: lastTab, fetching: true });
    this.fetchCrqData();
  }

  fetchCrqData() {
    const currentNetwork = this.props.network;
    getMyCRQCoordinatorCrqDashboard(currentNetwork).then(({ results, stats }) => {
      // DISPATCH HERE FREYJA
      this.setState({
        stats,
        crqLists: results,
        fetching: false,
        hasError: false,
      });
    }).catch((error) => {
      console.error(error);
      this.setState({
        fetching: false,
        hasError: true,
      });
    });
  }

  clearError() {
    this.setState({ hasError: false, fetching: false });
  }

  handleTabClick(tab) {
    this.setState({ selectedTab: tab, fetching: true });
    this.fetchCrqData();
  }

  render() {
    const {
      selectedTab,
      stats,
      fetching,
      crqLists,
      hasError,
    } = this.state;

    if (hasError) {
      return (
        <CrqListErrorAlert
          clearError={this.clearError}
        />
      );
    }
    if (fetching && !crqLists) {
      return (
        <div className="home-screen-loader">
          <LoadingSpinner />
        </div>
      );
    }
    const getStats = () => {
      let result = stats;
      if (INITIAL_COMMS_SENT in result) {
        const res = crqLists[INITIAL_COMMS_SENT].filter((item) => item);
        result = { ...result, [INITIAL_COMMS_SENT]: res.length };
      }
      if (APPROVED in stats) {
        const time = moment.tz(DEFAULT_TIMEZONE).valueOf();
        const res = crqLists[APPROVED].filter((item) => moment(item.end_date).valueOf() > time);
        result = { ...result, [APPROVED]: res.length };
      }
      return result;
    };
    const crqList = (crqLists && crqLists[selectedTab]) || [];
    return (
      <MyCoordinatorWorkQueueDisplay
        crqList={crqList}
        selectedTab={selectedTab}
        handleTabClick={this.handleTabClick}
        stats={getStats()}
        fetching={fetching}
        network={this.props.network}
      />
    );
  }
}

MyCoordinatorWorkQueue.propTypes = {
  network: PropTypes.string,
};

export { MyCoordinatorWorkQueue };
